export function isEnum(inputEnum) {
  return function (token) {
    return Object.values(inputEnum).includes(token);
  };
}